import {
  Component,
  Input,
  OnChanges,
  OnInit,
  output,
  SimpleChanges,
} from '@angular/core';
import { IMAGE_SRC, STATUS_OPTIONS } from '../../../shared-constants';
import { TwoColumnFormData } from '../two-column-form.constants';

@Component({
  selector: 'app-column-form',
  templateUrl: './column-form.component.html',
  styleUrls: ['./column-form.component.scss'],
  standalone: false,
})
export class ColumnFormComponent implements OnInit, OnChanges {
  @Input({ required: true }) header!: string;
  @Input({ required: true }) buttonText!: string;
  @Input({ required: true }) data!: TwoColumnFormData[];
  @Input({ required: true }) disable!: boolean;
  @Input() iconName = '';
  @Input() searchPlaceholder = '';
  @Input() isGroupForm!: boolean;

  emitCheckboxesSelected = output<boolean>();
  emitAssignUnassign = output<TwoColumnFormData[]>();

  readonly SELECT_TEXT = STATUS_OPTIONS.ALL_SELECTED;
  readonly IMAGES = IMAGE_SRC;

  displayedData!: TwoColumnFormData[];
  searchValue!: string;
  allSelected = false;
  isButtonDisabled = true;

  ngOnInit(): void {
    this.displayedData = this.data;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.data?.firstChange && changes.data?.currentValue) {
      this.displayedData = changes.data.currentValue;
      this.allSelected = false;
      this.isButtonDisabled = true;
    }
  }

  onAllSelect(): void {
    this.data?.forEach((value) => (value.selected = this.allSelected));
    const numberItemsSelected = this.selectedValues?.length;
    this.isButtonDisabled = numberItemsSelected === 0;
    this.emitCheckboxesSelected.emit(this.isButtonDisabled);
  }

  search(searchData: string): void {
    if (searchData === '') {
      this.displayedData = this.data;
    } else {
      const filteredValues = this.data.filter((value: TwoColumnFormData) => {
        const searchField = this.isGroupForm
          ? value.data.code
          : value.data.name;
        return searchField
          ?.toString()
          .toLowerCase()
          .includes(searchData.toLowerCase());
      });

      this.displayedData = [...filteredValues];
    }
  }

  clearSearch() {
    this.searchValue = '';
    this.displayedData = this.data;
  }

  onAssignUnassignClick(): void {
    this.emitAssignUnassign.emit(this.selectedValues);
    this.data.forEach((value) => {
      value.selected = false;
    });
    this.allSelected = false;
  }

  onCheckboxChanges() {
    const numberItemsSelected = this.selectedValues.length;
    this.allSelected = numberItemsSelected === this.data.length;
    this.isButtonDisabled = numberItemsSelected === 0;
    this.emitCheckboxesSelected.emit(this.isButtonDisabled);
  }

  get selectedValues() {
    return this.data?.filter((value) => !!value.selected);
  }

  get showAltSearch() {
    return this.searchValue?.length > 0;
  }
}
